import { Link } from 'react-router-dom';
import type { SiteItem } from '@/mocks/navigation';

interface SiteCardProps {
  site: SiteItem;
  categoryName: string;
  rank?: number;
}

export default function SiteCard({ site, categoryName, rank }: SiteCardProps) {
  const initials = site.name.slice(0, 2);

  return (
    <article className="group flex flex-col h-full rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-300">
      <div className="flex items-start gap-3">
        <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 font-heading text-sm">
          {initials}
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            {typeof rank === 'number' && (
              <span className="font-label text-[11px] px-1.5 py-0.5 rounded bg-foreground-900 text-background-50">
                #{rank}
              </span>
            )}
            <a
              href={site.url}
              target="_blank"
              rel="noopener nofollow"
              title={`${site.name} - ${categoryName}站点`}
              className="font-heading text-base font-bold text-foreground-950 hover:text-primary-600 transition-colors break-all"
            >
              {site.name}
            </a>
            {site.hot && (
              <span className="font-label text-[11px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-900 whitespace-nowrap">
                热门
              </span>
            )}
          </div>
          <Link
            to={`/category/${site.category}`}
            className="mt-1 inline-flex items-center gap-1 font-label text-xs text-foreground-500 hover:text-secondary-700 transition-colors"
          >
            <i className={site.category === 'hot' ? 'ri-fire-line' : 'ri-price-tag-3-line'} aria-hidden="true"></i>
            {categoryName}
          </Link>
        </div>
      </div>

      <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-2">{site.desc}</p>

      <div className="mt-3 flex flex-wrap gap-1.5">
        {site.tags.map((tag) => (
          <span
            key={tag}
            className="font-label text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900"
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="mt-auto pt-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 font-label text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
            热度 {site.heat}万
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
            {site.score}
          </span>
        </div>
        <a
          href={site.url}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-1 h-8 px-3 rounded-md bg-primary-500 text-background-50 font-label text-xs whitespace-nowrap hover:bg-primary-600 transition-colors"
        >
          访问站点
          <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
        </a>
      </div>
    </article>
  );
}